import sprite from './interfaz.svg?raw';

/**
 * Los iconos van en un solo archivo, como <symbol>, y pintados con el color del texto: el mismo icono sirve en
 * claro, en oscuro y sobre color. Se genera con `npm run iconos` desde tools/iconos/interfaz.json.
 */
export type NombreDeIcono =
  | 'marcas' | 'inicio' | 'marca' | 'estrategia' | 'redes' | 'identidad' | 'persona' | 'plan' | 'textos'
  | 'disenos' | 'videos' | 'publicar' | 'historial' | 'reloj' | 'trabajando' | 'buscar' | 'luna' | 'sol'
  | 'idea' | 'creditos' | 'mas' | 'check' | 'flecha' | 'flecha-larga' | 'ayuda' | 'refrescar' | 'ajustes'
  | 'cerrar' | 'menu' | 'campana' | 'estrella' | 'corazon' | 'chat' | 'nube' | 'editar' | 'papelera'
  | 'descargar' | 'ojo' | 'punto' | 'carrusel' | 'play' | 'pausa'
  // De línea, para lo que antes eran figuras 3D (06-10-2026).
  | 'rayo' | 'diamante' | 'cohete' | 'escudo' | 'trofeo' | 'regalo' | 'hoja' | 'bolsa' | 'taza' | 'pin' | 'grafico' | 'mundo';

/** Se pinta una sola vez, al principio del documento. */
export function Iconos() {
  return <div aria-hidden="true" style={{ display: 'none' }} dangerouslySetInnerHTML={{ __html: sprite }} />;
}

export function Icono({ nombre, clase }: { nombre: NombreDeIcono; clase?: string }) {
  return (
    <svg className={clase ? `ic ${clase}` : 'ic'} aria-hidden="true">
      <use href={`#i-${nombre}`} />
    </svg>
  );
}
